<cll-form-field [label]="label" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <input #inputRef
           cllFormInput
           type="text"
           autocomplete="off"
           role="combobox"
           aria-haspopup="listbox"
           aria-autocomplete="list"
           [attr.aria-expanded]="isOpen && filteredSuggestions.length > 0"
           [attr.aria-controls]="listboxId"
           [attr.aria-activedescendant]="activeIndex >= 0 ? listboxId + '-' + activeIndex : null"
           [attr.maxlength]="maxLength || null"
           [formControl]="inputControl"
           (focus)="onFocus()"
           (blur)="onBlur()" />
</cll-form-field>

<ng-template
    cdkConnectedOverlay
    cdkConnectedOverlayPanelClass="suggestions-overlay-pane"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen && filteredSuggestions.length > 0"
    [cdkConnectedOverlayWidth]="panelWidth"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (attach)="lockAncestorScroll()"
    (detach)="unlockAncestorScroll()">

    <div [id]="listboxId" class="suggestions-panel" role="listbox">
        <div class="suggestion-option"
             role="option"
             *ngFor="let option of filteredSuggestions; let i = index"
             [id]="listboxId + '-' + i"
             [attr.aria-selected]="i === activeIndex"
             [class.active]="i === activeIndex"
             (mousedown)="selectOption(option)">
            {{ option }}
        </div>
    </div>
</ng-template>
